import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { AssetStatusType } from '@design-stack-vista/vista-assets-sdk';
import { observer } from 'mobx-react-lite';
import { Icon, Typography } from '@vp/swan';
import { css } from '@emotion/css';
import { useFileMethods } from '../../../../UploadManagerProvider';
import { useCustomEventPropagation } from '../../../../CustomEventPropagationProvider';
import { useDrawerThumbnailAsset } from './DrawerThumbnailAssetProvider';
import { useLocalization } from '../../../../Localization';
import { useDrawerData } from '../../DrawerProvider';
import { DrawerThumbnailDeleteImageModal } from './DrawerThumbnailDeleteImageModal';
import { isMobile } from '../../utils';
const deleteStyle = css `
    visibility: hidden;
    position: absolute;
    top: 5px;
    right: 5px;
    max-width: 26px;
    width: 28%;
    max-height: 26px;
    height: 28%;
    background-color: black;
    border: unset;
    padding: unset;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    path {
        stroke: #ffffff;
    }
`;
const mobileDeleteStyle = css `
    position: absolute;
    bottom: -22px;
    background: none;
    border: none;
    // increase the specificity
    && {
        text-decoration: underline;
    }
`;
/**
 * Button to initiate a delete for an asset
 */
export const DrawerThumbnailDeleteButton = observer(() => {
    const { asset, asset: { status }, } = useDrawerThumbnailAsset();
    const { deleteButtonTitle } = useLocalization();
    const { disableDeleteButton, deleteOption } = useDrawerData();
    const [showConfirmation, setShowConfirmation] = useState(false);
    const { fireEvent } = useCustomEventPropagation();
    const { deleteFile } = useFileMethods();
    const onDelete = () => {
        fireEvent({ name: 'delete_upload', extraData: {} });
        deleteFile(asset);
    };
    const handleClick = (e) => {
        e.stopPropagation();
        // If deleteOption is not defined, default to 'quick' behavior
        if (!deleteOption || deleteOption === 'quick') {
            onDelete();
        }
        else {
            // deleteOption is 'none' or 'confirm', but for 'none' the button isn't shown anyway
            setShowConfirmation(true);
        }
    };
    const onClose = () => {
        setShowConfirmation(false);
    };
    const onConfirm = () => {
        onDelete();
        setShowConfirmation(false);
    };
    // Preserve the behavior of disableDeleteButton for the time being.
    if (disableDeleteButton || deleteOption === 'none') {
        return null;
    }
    if (!deleteButtonTitle) {
        // We can't have a button without a title
        throw Error('You must define a deleteButtonTitle in the Localization Provider');
    }
    if (status.type !== AssetStatusType.Prepared) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(DrawerThumbnailDeleteImageModal, { showDeleteImageModal: showConfirmation, onConfirm: onConfirm, onRequestDismiss: onClose }), isMobile() ? (_jsx("button", Object.assign({ className: mobileDeleteStyle, onClick: handleClick }, { children: _jsx(Typography, Object.assign({ fontSize: "standard" }, { children: deleteButtonTitle })) }))) : (_jsx("button", Object.assign({ className: deleteStyle, onClick: handleClick, "aria-label": deleteButtonTitle, title: deleteButtonTitle, "data-testid": "drawer-delete-button" }, { children: _jsx(Icon, { iconType: "deleteStudio", skin: "white", title: deleteButtonTitle, margin: 0, size: "16p" }) })))] }));
});
DrawerThumbnailDeleteButton.displayName = 'DrawerThumbnailDeleteButton';
//# sourceMappingURL=DrawerThumbnailDeleteButton.js.map